import React, {useEffect} from 'react';
import {useSelector} from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {SGP} from "../../pages/Competition/sgp-results-react";
import {getEventDatesString} from "../../pages/Calendar";
import {useLocation} from "react-router-dom";
import DaySelector from "./DaySelector";



const EventHeading = ({}) => {
    const event = useSelector(state => state.session.event)
    const day = useSelector(state=> state.session.day)
    const location = useLocation()

    const [showDaySelector,setShowDaySelector] = React.useState()

    useEffect(() => {
        setShowDaySelector(location.pathname.includes('/briefing'))
    }, [location]);

    return (
        <>
            {event &&
                <Box sx={{
                    textAlign:'left',
                    bgcolor:'#113248',
                    color:'#ffffff',
                    display:'flex',
                    alignItems:'center',
                    columnGap:'1.5em',
                    flexWrap:'wrap',
                    py:'4px',
                    px:'1em',
                }}>
                    <Box sx={{display:'flex',alignItems:'center'}}>
                        <img src='/etc/img/sgp-series-logo-v3.png' alt="SGP" style={{width:'46px'}}/>
                    </Box>
                    {showDaySelector &&
                        <>
                            <Typography variant={'h6'} sx={{whiteSpace:'nowrap'}}>{event.fullEditionTitle}</Typography>
                            <Typography variant={'body1'} sx={{whiteSpace:'nowrap'}}>{day ? day.t : getEventDatesString(event)}</Typography>
                            <DaySelector/>
                        </>
                    }
                    {!showDaySelector &&
                        <>
                            <Typography variant={'h6'} sx={{display:{md:'block',xs:'none'}}}>{SGP.getChampionshipTitle(event)}</Typography>
                            <Typography variant={'h6'}>{event.fullEditionTitle}</Typography>
                            <Typography variant={'body1'}  sx={{display:{sm:'block',xs:'none'}}}>{event.venue}</Typography>
                            <Typography variant={'body1'}>{getEventDatesString(event)}</Typography>
                        </>
                    }
                </Box>
            }
        </>
    );
};

export default EventHeading;